module.exports = __webpack_public_path__ + "img/info_12.996b5b21.jpeg";